import { render, staticRenderFns } from "./ActivateProfile.vue?vue&type=template&id=4a2859ab"
import script from "./ActivateProfile.vue?vue&type=script&lang=js"
export * from "./ActivateProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports